module.exports = __webpack_public_path__ + "static/header-icon.58e81f01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/header-icon.svg
// module id = 894
// module chunks = 168707334958949